<div class="min-h-screen bg-surface-50 dark:bg-surface-950">
  <header
    class="flex items-center justify-between border-b border-zinc-200 px-4 py-3 dark:border-zinc-700"
    style="background-color: #010617;"
  >
    @if (showBack()) {
    <button
      type="button"
      class="flex h-8 w-8 items-center justify-center rounded-full text-white dark:hover:bg-zinc-800"
      (click)="goBack()"
    >
      <i class="pi pi-arrow-left"></i>
    </button>
    }
    @if (title()) {
    <span class="flex-1 truncate text-base font-semibold text-white">{{ title() }}</span>
    } @else {
    <img src="/layout/images/logo-white.svg" alt="Mark ERP" class="h-6" />
    }
    <div class="flex items-center gap-2">
      <span class="truncate text-sm text-white">{{ userName() }}</span>
      <button
        type="button"
        class="flex h-8 w-8 items-center justify-center rounded-full text-white hover:bg-zinc-100 dark:hover:bg-zinc-800"
        (click)="onLogout()"
      >
        <i class="pi pi-power-off"></i>
      </button>
    </div>
  </header>
  <main class="p-4">
    <router-outlet></router-outlet>
  </main>
</div>
